<div class="one" fxLayout="column" [formGroup]="MatterPropertyDetailsForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- matTooltip="{{allToolTip.ADDRESS1?.HOVER}}" -->
    <!-- [ngClass]="{'has-error':errorWarningData.Error?.ADDRESS1,'has-warning':errorWarningData.Warning?.ADDRESS1}" -->
    <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
      <mat-label>Search for Address</mat-label>
      <input
        type="text"
        id="addressInput"
        name="ADDRESS1"
        formControlName="ADDRESS1"
        matInput
        placeholder="Start typing to search for an address"
        #addressInput
        [matAutocomplete]="auto"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        @for (option of searchData; track option; let i = $index) {
          <mat-option [value]="option.COMBINED" (onSelectionChange)="setAutoField(option, 1)">
            {{ option.COMBINED }}
          </mat-option>
        }
      </mat-autocomplete>
      <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap" (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.ADDRESS1?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.ADDRESS1?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BUILDINGNAME),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BUILDINGNAME),
      }"
    >
      <mat-label>Building Name</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.BUILDINGNAME?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="BUILDINGNAME"
      />
      @if (testBool && toolTipList.BUILDINGNAME) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.BUILDINGNAME.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.BUILDINGNAME?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.UNITNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.UNITNUMBER),
      }"
    >
      <mat-label>Unit No.</mat-label>
      <input
        matInput
        name="Unit No"
        matTooltip="{{ toolTipList ? toolTipList.UNITNUMBER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="UNITNUMBER"
      />
      @if (testBool && toolTipList.UNITNUMBER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.UNITNUMBER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.UNITNUMBER?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STREETNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STREETNUMBER),
      }"
    >
      <mat-label>Street No</mat-label>
      <input
        matInput
        name="StreetNo"
        matTooltip="{{ toolTipList ? toolTipList.STREETNUMBER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="STREETNUMBER"
      />
      @if (testBool && toolTipList.STREETNUMBER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.STREETNUMBER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.STREETNUMBER?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="10"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STREETNUMBERTO),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STREETNUMBERTO),
      }"
    >
      <mat-label>To</mat-label>
      <input
        matInput
        name="To"
        matTooltip="{{ toolTipList ? toolTipList.STREETNUMBERTO?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="STREETNUMBERTO"
      />
      @if (testBool && toolTipList.STREETNUMBERTO) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.STREETNUMBERTO.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.STREETNUMBERTO?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="30"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STREETNAME),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STREETNAME),
      }"
    >
      <mat-label>Street</mat-label>
      <input
        name="Street"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.STREETNAME?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="STREETNAME"
      />
      @if (testBool && toolTipList.STREETNAME) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.STREETNAME.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.STREETNAME?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STREETTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STREETTYPE),
      }"
    >
      <mat-label>Street Type</mat-label>
      <input
        type="text"
        placeholder="Street"
        aria-label="Number"
        matInput
        name="STREETTYPE"
        matTooltip="{{ toolTipList ? toolTipList.STREETTYPE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="STREETTYPE"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete #auto="matAutocomplete">
        @for (val of StreetType; track val) {
          <mat-option value="{{ val.LOOKUPFULLVALUE }}">
            {{ val.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (testBool && toolTipList.STREETTYPE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.STREETTYPE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.STREETTYPE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="30"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SUBURB),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SUBURB),
      }"
    >
      <mat-label>Suburb</mat-label>
      <input
        matInput
        name="Suburb"
        matTooltip="{{ toolTipList ? toolTipList.SUBURB?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="SUBURB"
      />
      @if (testBool && toolTipList.SUBURB) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.SUBURB.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.SUBURB?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STATE),
      }"
    >
      <mat-label>State</mat-label>
      <input
        type="text"
        placeholder="State"
        aria-label="Number"
        matInput
        name="STATE"
        matTooltip="{{ toolTipList ? toolTipList.STATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="STATE"
        [matAutocomplete]="auto3"
      />
      <mat-autocomplete #auto3="matAutocomplete">
        @for (val of StateData; track val) {
          <mat-option value="{{ val.LOOKUPFULLVALUE }}">
            {{ val.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (testBool && toolTipList.STATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.STATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.STATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.POSTCODE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.POSTCODE),
      }"
    >
      <mat-label>Post Code</mat-label>
      <input
        matInput
        name="PostCode"
        matTooltip="{{ toolTipList ? toolTipList.POSTCODE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="POSTCODE"
      />
      @if (testBool && toolTipList.POSTCODE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.POSTCODE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.POSTCODE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    fxFlex="1 0 auto"
    [ngClass]="{
      'has-error': $safeNavigationMigration(errorWarningData.Error?.NATUREOFBUILDING),
      'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NATUREOFBUILDING),
    }"
  >
    <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
      <mat-label>Nature Of Building</mat-label>
      <input
        matInput
        name="NatureOfBulding"
        matTooltip="{{ toolTipList ? toolTipList.NATUREOFBUILDING?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="NATUREOFBUILDING"
      />
      @if (testBool && toolTipList.NATUREOFBUILDING) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.NATUREOFBUILDING.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.NATUREOFBUILDING?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
